import add from '@/ajax/cart/add';
import update from '@/ajax/cart/update';
import get from '@/ajax/cart/get';
import remove from '@/ajax/cart/remove';

/**
 * @module ajaxAPI/cart
 *
 * @description
 * Ajax-обертки для работы с корзиной
 */

const cart = {
  add,
  update,
  get,
  remove
};

export default cart;
